/** @jsx jsx */
import React, { useContext, useState, useCallback } from 'react'
import { getEnvConfig, getPermitActions, getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import { rowHeaderRender, hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import { jsx } from '@emotion/core'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import Grid, {
  virtualizedGridRenderer,
  defaultVirtualizedCellRender,
} from '@integec/grid-tools'
import { dateCol, numCol, strCol, intCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { Button, DatePicker, Input, message, Tabs, Upload, Icon } from 'antd'
import { getSwitchBoardMNS, getAuthorization, getCredentials } from 'api/pgads'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
import qs from 'querystring'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

const MNS = ({ envConfig, actionPermits, apiTargetInfo }) => {
  const { authGodMode } = envConfig

  // eslint-disable-next-line no-unused-vars
  const importPermisiion = hasAccesPermits({
    authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.SWITCHBOARD_IMPORT],
    matchAny: true,
  })
  const [importResult, setImportReult] = useState([])

  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [dataMNS, setDataMNS] = useState({
    detailData: [],
    metaData: [],
    statusData: [],
  })
  const [fuzzyFilter, setFuzzyFilter] = useState([])
  const retrieve = ({ date = selectedDate }) => {
    setSpinning(true)
    getSwitchBoardMNS(apiTargetInfo)(date).fork(setError, data => {
      setDataMNS(data)
      setSpinning(false)
    })
  }

  const cellRender = props => {
    const { gridToolProps, reactVirtualizedProps } = props
    const { getCellProps, headers, data } = gridToolProps
    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    const { station, unit, transdate, transhour } = data[rowIndex]

    const cellProps = getCellProps({
      rowIndex,
      columnIndex,
      header: headers[columnIndex],
      data,
      style,
    })

    const statusData =
      (dataMNS.statusData || []).find(
        f =>
          f.station === station &&
          f.unit === unit &&
          f.transdate === transdate &&
          f.transhour === transhour
      ) || {}
    const headerIdent = headers[columnIndex].ident
    const statusValue = statusData[headerIdent]

    // const style = reactVirtualizedProps.style
    return defaultVirtualizedCellRender({
      ...props,
      style: {
        ...style,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        borderTop: '1px solid #cc',
        backgroundColor:
          statusValue === 'E'
            ? 'yellow'
            : cellProps.isSelected
            ? '#F8F8F8'
            : 'white',
        color: cellProps.isSelected ? 'black' : undefined,
      },
    })
  }

  const url = ft =>
    `${apiTargetInfo.baseUrl}/switchboard/import-mns?${qs.stringify({
      fileType: ft,
    })}`
  const fileProps = {
    name: 'file',
    action: url('mns'),
    method: 'POST',
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }

  const onFileUploadChange = useCallback(
    info => {
      if (info.file.status === 'done') {
        setSpinning(false)
        message.success(`${info.file.name} file uploaded successfully`)
        // setImportResponse(info.file.response)
        // message.info(info.file.response)
        setImportReult(info.file.response)
        // retrieveData()
      } else if (info.file.status === 'error') {
        setSpinning(false)
        // reportError(info.file.response)
        // onError(info)
        setError(info.file.response)
        if (info.file.response.appExceptionId !== 100)
          message.error(`${info.file.name} file have invalid data`)
      }
    },
    [setError, setSpinning]
  )

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <JcTmpErrorDialog
        visible={importResult.length > 0}
        errors={importResult}
        closeErrorPrompt={_ => setImportReult([])}
      />

      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            width: '250px',
          }}
        >
          MNS
        </Title>
        <DatePicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            if (d && d.isValid) {
              setSelectedDate(d)
              retrieve({ date: d })
            }
          }}
        />

        <Button
          icon="database"
          loading={spinning}
          onClick={_ => retrieve({ date: selectedDate })}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Retrieve
        </Button>

        <Filler />
        {importPermisiion && (
          <Upload
            {...fileProps}
            onChange={data => {
              setSpinning(true)
              onFileUploadChange(data)
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button>
              <Icon type="upload" /> Import
            </Button>
          </Upload>
        )}
        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{ marginLeft: '10px', marginRight: '10px', maxWidth: '200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={240}>
        {({ height, width }) => (
          <Content css={{ height: height - 20, paddingTop: '10px' }}>
            <Tabs type="card">
              <Tabs.TabPane tab="Metadata" key="metadata">
                <div css={{ minWidth: '500px', minHeight: '500px' }}>
                  <Grid
                    fuzzyFilter={fuzzyFilter}
                    sortEnabled={false}
                    data={dataMNS.metaData}
                    headers={IfSwbdMnsMHeaders}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 150,
                      headerRowHeight: 30,
                    })}
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Detail data" key="detaildata">
                <div css={{ minWidth: '500px', minHeight: '500px' }}>
                  <Grid
                    fuzzyFilter={fuzzyFilter}
                    sortEnabled={false}
                    data={dataMNS.detailData}
                    headers={IfSwbdMnsDHeaders}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 50,
                      headerRowHeight: 30,
                      cellRender,
                    })}
                    sortOptions={[
                      {
                        ident: 'station',
                        display: 'Station',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'unit',
                        display: 'Unit',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'transdate',
                        display: 'Transdate',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'transhour',
                        display: 'Transhour',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                    ]}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  apiTargetInfo: getApiTargetInfo(state),
})
export default connect(mapStateToProps)(MNS)

const IfSwbdMnsDHeaders = [
  strCol({ ident: 'station', display: 'Station', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
  intCol({
    ident: 'transhour',
    display: 'Transhour',
    displayFormat: '0.0',
  }),
  numCol({ ident: 'stationNet', display: 'Station Net', isFiltered: true }),
  numCol({ ident: 'unitNet', display: 'Unit Net', isFiltered: true }),
  numCol({ ident: 'totalGross', display: 'Total Gross', isFiltered: true }),
  numCol({ ident: 'totalAux', display: 'Total Aux', isFiltered: true }),
  numCol({
    ident: 'grossMwhMeter',
    display: 'Gross MWH Meter',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'grossMwhDiff',
    display: 'Gross MWH Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'transAtaMeter',
    display: 'Trans ATA Meter',
    isFiltered: true,
  }),
  numCol({
    ident: 'transAtaDiff',
    display: 'Trans ATA Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'transAtbMeter',
    display: 'Trans ATB Meter',
    isFiltered: true,
  }),
  numCol({
    ident: 'transAtbDiff',
    display: 'Trans ATB Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'transAteMeter',
    display: 'Trans ATE Meter',
    isFiltered: true,
  }),
  numCol({
    ident: 'transAteDiff',
    display: 'Trans ATE Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'dieselAMeter',
    display: 'Diesel A Meter',
    isFiltered: true,
  }),
  numCol({ ident: 'dieselADiff', display: 'Diesel A Diff', isFiltered: true }),
  numCol({
    ident: 'dieselBMeter',
    display: 'Diesel B Meter',
    isFiltered: true,
  }),
  numCol({ ident: 'dieselBDiff', display: 'Diesel B Diff', isFiltered: true }),
  numCol({ ident: 'ssfdMeter', display: 'SSFD Meter', isFiltered: true }),
  numCol({ ident: 'ssfdDiff', display: 'SSFD Diff', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
].map(d =>
  d.type === 'num' && d.ident !== 'transhour'
    ? { ...d, displayFormat: '000,000,000.00' }
    : d
)

const IfSwbdMnsMHeaders = [
  strCol({ ident: 'station', display: 'Station', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
  strCol({
    ident: 'netgenEquation',
    display: 'Netgen Equation',
    isFiltered: true,
    width: 700,
  }),
  strCol({ ident: 'stationNet', display: 'Station Net', isFiltered: true }),
  strCol({ ident: 'unitNet', display: 'Unit Net', isFiltered: true }),
  strCol({ ident: 'totalGross', display: 'Total Gross', isFiltered: true }),
  strCol({ ident: 'totalAux', display: 'Total Aux', isFiltered: true }),
  strCol({
    ident: 'grossMwhMeter',
    display: 'Gross MWH Meter',
    isFiltered: true,
    width: 150,
  }),
  strCol({
    ident: 'grossMwhDiff',
    display: 'Gross MWH Diff',
    isFiltered: true,
  }),
  strCol({
    ident: 'transAtaMeter',
    display: 'Trans ATA Meter',
    isFiltered: true,
  }),
  strCol({
    ident: 'transAtaDiff',
    display: 'Trans ATA Diff',
    isFiltered: true,
  }),
  strCol({
    ident: 'transAtbMeter',
    display: 'Trans ATB Meter',
    isFiltered: true,
  }),
  strCol({
    ident: 'transAtbDiff',
    display: 'Trans ATB Diff',
    isFiltered: true,
  }),
  strCol({
    ident: 'transAteMeter',
    display: 'Trans ATE Meter',
    isFiltered: true,
  }),
  strCol({
    ident: 'transAteDiff',
    display: 'Trans ATE Diff',
    isFiltered: true,
  }),
  strCol({
    ident: 'dieselAMeter',
    display: 'Diesel A Meter',
    isFiltered: true,
  }),
  strCol({ ident: 'dieselADiff', display: 'Diesel A Diff', isFiltered: true }),
  strCol({
    ident: 'dieselBMeter',
    display: 'Diesel B Meter',
    isFiltered: true,
  }),
  strCol({ ident: 'dieselBDiff', display: 'Diesel B Diff', isFiltered: true }),
  strCol({ ident: 'ssfdMeter', display: 'SSDF Meter', isFiltered: true }),
  strCol({ ident: 'ssfdDiff', display: 'SSFD Diff', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
]

// const IfSwbdMnsSHeaders = [
//   strCol({ ident: 'station', display: 'Station', isKey: true }),
//   strCol({ ident: 'unit', display: 'Unit', isKey: true }),
//   dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
//   numCol({ ident: 'transhour', display: 'Transhour', isKey: true }),
//   strCol({ ident: 'stationNet', display: 'StationNet', isFiltered: true }),
//   strCol({ ident: 'unitNet', display: 'UnitNet', isFiltered: true }),
//   strCol({ ident: 'totalGross', display: 'TotalGross', isFiltered: true }),
//   strCol({ ident: 'totalAux', display: 'TotalAux', isFiltered: true }),
//   strCol({
//     ident: 'grossMwhMeter',
//     display: 'GrossMwhMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'grossMwhDiff', display: 'GrossMwhDiff', isFiltered: true }),
//   strCol({
//     ident: 'transAtaMeter',
//     display: 'TransAtaMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'transAtaDiff', display: 'TransAtaDiff', isFiltered: true }),
//   strCol({
//     ident: 'transAtbMeter',
//     display: 'TransAtbMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'transAtbDiff', display: 'TransAtbDiff', isFiltered: true }),
//   strCol({
//     ident: 'transAteMeter',
//     display: 'TransAteMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'transAteDiff', display: 'TransAteDiff', isFiltered: true }),
//   strCol({ ident: 'dieselAMeter', display: 'DieselAMeter', isFiltered: true }),
//   strCol({ ident: 'dieselADiff', display: 'DieselADiff', isFiltered: true }),
//   strCol({ ident: 'dieselBMeter', display: 'DieselBMeter', isFiltered: true }),
//   strCol({ ident: 'dieselBDiff', display: 'DieselBDiff', isFiltered: true }),
//   strCol({ ident: 'ssfdMeter', display: 'SsfdMeter', isFiltered: true }),
//   strCol({ ident: 'ssfdDiff', display: 'SsfdDiff', isFiltered: true }),
// ]
